/* DOMAIN-BASED! DO-NOT PUT IN GIT */

//export const apiUrl = 'http://red-elk.ru';
export const apiUrl = window.location.hostname === "localhost" ? "http://red-elk.ru" : "";